import type { DefaultTheme } from 'styled-components';

import { theme as dotTheme } from '@dot/design-system';

export const theme: DefaultTheme = dotTheme;
